<div *ngIf="active" class="vk-install">
  <h2 class="vk-install__title">Установка в сообщество ВКонтакте</h2>
  <p class="vk-install__text">
    Нажмите кнопку ниже, выберите сообщество и подтвердите установку.
  </p>
  <button
    type="button"
    class="vk-install__btn"
    [disabled]="state === 'installing' || state === 'binding'"
    (click)="onInstallClick()"
  >
    {{
      state === "installing" || state === "binding"
        ? "Установка…"
        : "Выбрать сообщество"
    }}
  </button>
  <p *ngIf="state === 'error'" class="vk-install__error">
    {{ error }}
  </p>
</div>
